export const availabilityModalStyles = {
  modalStyles: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: { xs: "80%", sm: "40%" },
    maxHeight: "90%",
    overflowY: "auto",
    width: { xs: "90%", md: "495px" },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "5px",
    margin: "0px 0px",
    p: { xs: 2, md: 5 },
  },
  modalShareStyles: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    overflowY: "auto",
    width: "1021px",
    maxHeight: "80%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
    margin: "0px 0px",
    padding: "24px 22px",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
  },
  headerText: {
    height: "34px",
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "34px",
    textAlign: "center",
    color: "#000"
  },

  bodyText: {
    fontSize: "17px",
    fontWeight: "400",
  },

  modalFooter: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    width: "100%",
    marginTop: "15px"
  },

  greenButton: {
    width: "150px",
    backgroundColor: "#2E7D32",
    fontWeight: 600,
    color: "#FFF",
    "&:hover": {
      backgroundColor: "#2E7D32",
    },
  },

  greenEditButton: {
    width: { xs: "100%", sm: "150px" },
    backgroundColor: "#2E7D32",
    fontWeight: 600,
    color: "#FFF",
    "&:hover": {
      backgroundColor: "#2E7D32",
    },
  },

  whiteButton: {
    width: "150px",
    borderColor: "#000",
    border: "1px solid #000",
    color: "#000",
    fontWeight: 600,
    "&:hover": {
      borderColor: "#000",
      backgroundColor: "#f5f5f5",
    },
  },

  circularProgress: { color: "white" },

  //   edit modal styles
  editHeader: {
    display: "flex",
    flexDirection: " row",
    textAlign: "center",
    height: "34px",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    marginBottom: "12px",
    width: "977px"
  },

  footerText: { fontSize: "13px", fontWeight: "400" },

  name: {
    fontSize: "17px",
    color: "#0D0D0D",
    lineHeight: "25.5px",
    letterSpacing: 0.347,
    marginBottom: "1px",
    fontWeight: 700,
  },
  company: {
    fontSize: "15px",
    color: "#000",
    marginBottom: "1px",
    fontWeight: 400,
  },
  location: {
    fontSize: 15,
    color: "#000",
    fontWeight: 400,
  },

  editModalHeading: { fontSize: "17px", fontWeight: "600" },
  editBodyContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 2,
    maxWidth: '480px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  editSingleContainer: { width: "40%" },
  timePickerButton: {
    border: "1px solid black",
    borderRadius: "8px",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "10px",
    paddingRight: "10px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  timePickerText: { fontSize: "16px", fontWeight: 400 },

  durationContainer: {
    minWidth: "60px",
    backgroundColor: "white",
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid black",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid black",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid black",
    },
    ".css-11bgdin-MuiSelect-icon": {
      top: "unset",
    },
  },
  timePickerDialog: {
    overflow: "hidden",
  },
  timePickerContainer: {
    p: 3,
  },

  timePickerHeaderText: {
    textAlign: "center",
    mb: 2,
  },

  timePickerScrollable: {
    maxHeight: "250px",
    overflowY: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },

  timePickerActions: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    mt: 3,
  },

  // Share availability modal styles
  searchInput: {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      padding: "2px 8px",
      fontSize: "15px",
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #ccc",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 0",
    },
  },

  modalBody: {
    height: "250px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f1f1",
    },
  },
  cardBody: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    paddingY: "6px",
    marginBottom: "8px",
  },

  cardBodyContainer: {
    flex: 1,
    paddingY: "10px",
    borderBottom: "0.5px solid black",
    borderColor: "#8D8D8D",
  },

  closeIcon: {
    position: "absolute",
    top: "0px",
    right: "10px",
    cursor: "pointer",
    width: "16px",
    height: "16px",
  } as const,

  searchContainer: {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    width: "977px",
    height: "40px",
    mt: 1,
    mb: "16px",
  },

  influencerListContainer: {
    mt: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },

  influencerCard: {
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    cursor: "pointer",
    p: 1.5,
    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
  },

  influencerImageContainer: {
    mr: 2,
    width: "80px",
    height: "80px",
    borderRadius: "8px",
    overflow: "hidden",
  },

  influencerImage: {
    cursor: "pointer",
    width: "80px",
    height: "80px",
    borderRadius: "8px",
  },

  influencerDetailsContainer: {
    display: "flex",
    flexDirection: "column",
  },

  influencerName: {
    fontSize: "16px",
    fontWeight: 600,
  },

  influencerType: {
    fontSize: "14px",
    color: "gray",
  },

  influencerLocation: {
    fontSize: "13px",
    color: "#888",
  },

  shareModalFooter: {
    mt: 3,
    display: "flex",
    gap: 3,
    justifyContent: "center"
  },

  shareButton: {
    backgroundColor: "#1aa260",
    color: "#fff",
    textTransform: "none",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#15834d",
    },
  },

  btnContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "20px",
    justifyContent: "center",
    alignItems: "center",
  },
  w80: { width: "80%" },

  // direct link modal
  directLinkHeader: {
    display: "flex",
    flexDirection: " row",
    justifyContent: "flex-end",
  },
  directLinkBodyContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "24px",
    alignItems: "center",
    paddingLeft: "16px",
    paddingRight: "16px"
  },
  customerName: {
    color: "#000",
    fontSize: "22px",
    fontWeight: "600",
    marginLeft: "16px",
  },
  cardTitle: {
    fontSize: "22px",
    fontWeight: "600",
    fontFamily: "Poppins",
    color: "#000",
    // lineHeight: 30,
    // letterSpacing: 0.081
  },
  cardDate: {
    fontSize: "20px",
    fontWeight: "500",
    color: "#000",
  },
  cardTime: {
    fontSize: "17px",
    fontWeight: "400",

    color: "#000",
    marginTop: "4px",
  },
  cardPrice: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#000",
    marginTop: "8px",
  },
  cardPays: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#000",
    marginTop: "4px",
  },

  boldText: {
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Poppins",
  },
  directLinkModalBody: {
    width: { xs: "80%", sm: "60%" },
    border: "1px solid #8D8D8D",
    borderRadius: "12px",
  },
  imageStyles: {
    width: "100%",
    height: "250px",
    objectFit: "cover",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  directLinkModalFooter: {
    width: { xs: "90%", sm: "70%" },
    display: "flex",
    flexDirection: "row",
    marginY: 1,
    gap: "12px",
  },
  flex1: {
    flex: 1,
    height: "39px",
    width: "151px",
    fontSize: "15px",
    fontWeight: "600",
    borderRadius: "8px",
    border: "1px solid #8D8D8D",
    fontFamily: "Poppins",
  },
};
